import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Breadcrumbs,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Link from "@mui/material/Link";
import axios from "axios";
import Layout from "../../layout/Layout";
import { AlertMessage } from "../../components/AlertMessage";
import { config, advanceReliefAPI, userData } from "../../config";

function AdvanceReliefApproverSettings() {
  const childRef = useRef();

  // Approver options = active super admins (intType 7).
  // Account options   = active accountants, role 35 (intType 9) -- the person
  // who disburses approved advances and marks them paid.
  const [approverList, setApproverList] = useState([]);
  const [approverID, setApproverID] = useState(0);
  const [accountList, setAccountList] = useState([]);
  const [accountID, setAccountID] = useState(0);
  const [loading, setLoading] = useState(false);

  const isSuperAdmin = Number(userData?.role_id) === 34;

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false && isSuperAdmin) {
      fetchOptions(7, setApproverList);
      fetchOptions(9, setAccountList);
      fetchApproverConfig();
      tempRefs.current = true;
    }
  }, []);

  const fetchOptions = (intType, setter) => {
    config.method = "POST";
    config.data = JSON.stringify({ intType });
    config.url = advanceReliefAPI;

    axios(config)
      .then(function (response) {
        setter(response.data.result || []);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchApproverConfig = () => {
    config.method = "POST";
    config.data = JSON.stringify({ intType: 5 });
    config.url = advanceReliefAPI;

    axios(config)
      .then(function (response) {
        const cfg = response.data.result && response.data.result[0];
        if (cfg) {
          setApproverID(Number(cfg.approver_emp_id) || 0);
          setAccountID(Number(cfg.account_emp_id) || 0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSave = () => {
    setLoading(true);
    config.method = "POST";
    config.data = JSON.stringify({
      intType: 6,
      intApproverID: approverID,
      intAccountID: accountID,
      intUpdatedBy: userData.emp_id,
    });
    config.url = advanceReliefAPI;

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.success) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: "success",
            })
          );
          fetchApproverConfig();
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message || "Something went wrong",
              messageType: "error",
            })
          );
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Something went wrong",
            messageType: "error",
          })
        );
      });
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Advance Relief Approver Settings
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">
                Advance Relief Approver Settings
              </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <div className="empty-space-40"></div>

        {!isSuperAdmin ? (
          <Typography color="error" sx={{ mt: 2 }}>
            You are not authorized to view this page.
          </Typography>
        ) : (
          <Grid
            container
            spacing={2}
            margin={`15px 0px`}
            padding={`10px 15px 0px 0px`}
          >
            <Grid item xs={12} lg={4} md={4}>
              <FormControl fullWidth>
                <InputLabel id="approver-select-label">
                  Advance Relief Approver
                </InputLabel>
                <Select
                  labelId="approver-select-label"
                  id="approver-select"
                  value={approverID}
                  label="Advance Relief Approver"
                  onChange={(e) => setApproverID(e.target.value)}
                >
                  <MenuItem value={0}>
                    <em>None</em>
                  </MenuItem>
                  {approverList.map((row) => (
                    <MenuItem value={row.id} key={row.id}>
                      {row.employee_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={4} md={4}>
              <FormControl fullWidth>
                <InputLabel id="account-select-label">
                  Advance Disbursing Account
                </InputLabel>
                <Select
                  labelId="account-select-label"
                  id="account-select"
                  value={accountID}
                  label="Advance Disbursing Account"
                  onChange={(e) => setAccountID(e.target.value)}
                >
                  <MenuItem value={0}>
                    <em>Any accountant</em>
                  </MenuItem>
                  {accountList.map((row) => (
                    <MenuItem value={row.id} key={row.id}>
                      {row.employee_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography
                variant="caption"
                sx={{ color: "text.secondary", mt: 0.5, display: "block" }}
              >
                Notified when an advance is approved; marks it paid, which
                notifies the employee.
              </Typography>
            </Grid>

            <Grid item xs={12} lg={4} md={4}>
              <LoadingButton
                size="large"
                variant="contained"
                color="primary"
                loading={loading}
                onClick={handleSave}
              >
                Save
              </LoadingButton>
            </Grid>
          </Grid>
        )}
      </Grid>
      <AlertMessage ref={childRef} />
    </Layout>
  );
}

export default AdvanceReliefApproverSettings;
